import { takeLatest, put, call } from 'redux-saga/effects'
// FIXS

import { getRichTextBlock } from 'api/lessons/block-instances/GetRichTextBlock'
import getSurveyBlock from 'api/lessons/block-instances/GetSurveyBlock'
import { getTaskBlock } from 'api/lessons/block-instances/GetTaskBlock'
import { getMultimediaBlock } from 'api/lessons/block-instances/GetMultimediaBlock'
import { getEvaluationBlock } from 'api/lessons/block-instances/GetEvaluationBlock'
import { getScormBlock } from 'api/lessons/block-instances/GetScormBlock'
import { getMeetingBlock } from 'api/lessons/block-instances/GetMeetingBlock'
import { getSessionBlock } from 'api/lessons/block-instances/GetSessionBlock'
import { BlockTypes } from 'enum/block-type.enum'
import { evaluationsService } from 'api/courses/evaluations'
import { IEvaluationResumeWithType } from 'models/evaluation.model'
import * as fromActions from '../../../actions/lessons.action'

interface IBlockInstanceSimple {
  id: number
  type: string
}

async function getLessonContentList(data: IBlockInstanceSimple[]) {
  const content = [] as any
  const promises: Promise<any>[] = data.map(async ({ id, type }) => {
    switch (type) {
      case BlockTypes.BlockSurvey:
        return getSurveyBlock(id)
      case BlockTypes.BlockRichText:
        return getRichTextBlock(id)
      case BlockTypes.BlockTask:
        return getTaskBlock(id)
      case BlockTypes.BlockMultimedia:
        return getMultimediaBlock(id)
      case BlockTypes.BlockEvaluation:
        return getEvaluationBlock(id)
      case BlockTypes.BlockScorm:
        return getScormBlock(id)
      case BlockTypes.BlockMeeting:
        return getMeetingBlock(id)
      case BlockTypes.BlockSession:
        return getSessionBlock(id)
      case BlockTypes.Evaluation:
        return evaluationsService
          .getEvaluation(id)
          .then((res): IEvaluationResumeWithType => {
            return { ...res, type: BlockTypes.Evaluation }
          })
      default:
        return null
    }
  })
  const result = await Promise.allSettled(promises)

  result.forEach((settled) => {
    if (settled.status === 'fulfilled' && settled.value != null) {
      content.push(settled.value)
    }
  })
  return content
}

export function* blockListEffectSaga(action: any) {
  try {
    const instancesIds: IBlockInstanceSimple[] = []
    const { blockInstances, lessonId } = action.payload
    console.log('blockInstances: ', blockInstances)
    blockInstances.map(async (instance: any) => {
      instance.lessonId === lessonId &&
        instancesIds.push({
          id: instance.blockInstanceableId,
          type: instance.blockInstanceableType,
        })
    })
    const data = yield call(getLessonContentList, instancesIds)
    yield put(fromActions.Actions.lessonsGetLessonContentSuccess(data))
  } catch (error) {
    console.log('error: ', error)
    yield put(fromActions.Actions.lessonsLoadFailure())
  }
}

export function* getLessonBlocksContentWatcherSaga() {
  yield takeLatest(fromActions.LESSONS_GET_LESSON_CONTENT, blockListEffectSaga)
}
